module.exports = __webpack_public_path__ + "static/media/icon-back.6dde695f.svg";